/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productDescriptionTitleSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-lg)',
		sm: 'var(--font-size-xl)',
	},
	color: '#2C2C2C',
	letterSpacing: '0px',
	textTransform: 'uppercase',
	opacity: 1,
	fontWeight: '800',

	marginTop: { xs: '10px', sm: '0' },
};

export const productDescriptionTextSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	color: '#2C2C2C',
	letterSpacing: '0px',
	opacity: 1,
	fontWeight: 'normal',
	marginTop: '8px',

	'h2, h4': {
		fontSize: '15px',
		color: '#2C2C2C',
		letterSpacing: '0px',
		opacity: 1,
		fontWeight: 'bold',
		my: '5px',
		textTransform: 'uppercase',
	},

	ol: {
		listStyleType: 'disc',
		paddingLeft: '0px',
		marginTop: '10px',
		display: 'flex',
		alignItems: 'center',
		gap: '16px',
		mb: 0,
	},

	'ol span': {
		fontSize: '15px',
		color: '#333',
		marginBottom: '8px',
		display: 'flex',
		alignItems: 'center',
		gap: '5px',

		'&::before': {
			content: '"•"',
			color: '#333',
			fontSize: '15px',
		},
	},

	'ul span, ul li, ul p': {
		fontSize: '15px',
		color: '#333',
		marginBottom: '8px',
		display: 'flex',
		alignItems: 'center',
		gap: '5px',

		'&::before': {
			content: '"•"',
			color: '#333',
			fontSize: '15px',
		},
	},
};

export const productDeyailsTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	color: '#2C2C2C',
	letterSpacing: '0px',
	opacity: 1,
	fontWeight: '800',
};
